import { fetchMatchingDrugsLabTests } from '../../api';
import { Drug, S_TYPE } from '../../api/fetchMatchingDrugsLabTests';
import { LOCAL_ID_PREFIX } from '../../constants';

export const onMedicineSearch = (
    text: string,
    cat?: string,
    generic_id?: string,
    cid?: string,
): Promise<Drug[]> => {
    return fetchMatchingDrugsLabTests(
        text,
        cat,
        generic_id,
        undefined,
        cid,
        undefined,
        S_TYPE.DRUG,
    ).then((res) => {
        const { drugs } = res;
        return drugs ? drugs.filter((i) => !i.id.startsWith(LOCAL_ID_PREFIX)) : [];
    });
};
